import { types } from './types.js';

export default {
    [types.CLOSE_TOKEN_EXPIRED] (state, { tokenExpired }) {
        state.tokenExpired = tokenExpired;
    },
    [types.OPEN_TOKEN_EXPIRED] (state, { tokenExpired }) {
        state.tokenExpired = tokenExpired;
    }
};